var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.26455 5.70156H7.79421M3.8287 7.35793H7.22771M10.0256 8.69758C10.0509 8.55513 10.0635 8.41079 10.0633 8.26622V5.34649C10.0729 4.02798 9.01207 2.95131 7.69356 2.94141H3.37212C3.24051 2.9411 3.10914 2.95186 2.97926 2.97363C1.82975 3.1765 0.993749 4.17837 1.00004 5.34571V11.9999L3.36976 10.6713H7.6912C8.84228 10.6638 9.82301 9.8338 10.0209 8.69994",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.98047 2.97372C3.17753 1.83805 4.15991 1.0066 5.31248 1H9.63392C10.9515 1.01124 12.0109 2.08751 12.0013 3.40508V6.32481C12.0091 7.49333 11.1728 8.49692 10.0221 8.70003",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCommentIcon);
export default __webpack_public_path__ + "static/media/AddComment_icon.3dba1ca0678926793338f6830483ee5a.svg";
export { ForwardRef as ReactComponent };